import { render, staticRenderFns } from "./GalleryCollection.vue?vue&type=template&id=4a81d7e8&scoped=true"
import script from "./GalleryCollection.vue?vue&type=script&lang=js"
export * from "./GalleryCollection.vue?vue&type=script&lang=js"
import style0 from "./GalleryCollection.vue?vue&type=style&index=0&id=4a81d7e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a81d7e8",
  null
  
)

export default component.exports